enum LangKey {
  EN = 'en'
}

export const getLangKey = () => LangKey.EN;
